import React from 'react';
import styled from 'styled-components';
import Marquee from '@/components/landing/product/sub/Logos';
import LazyVideo from '@/components/landing/common/LazyVideo'
import { breakpoints } from '@/layouts/breakpoints';

const StyledComp = styled.div`
padding: 120px 0;
padding-bottom: 200px;

@media (max-width: ${breakpoints.small}) {
  padding: 20px 0;
}

.grid{
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  padding: 80px 40px;
  max-width: 1400px;
  margin: 0 auto;


  @media (max-width: ${breakpoints.small}) {
    padding: 80px 24px;
  }

  .eyebrow {
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgb(var(--greyr));
    font-size: 13px;
  }

  .eyebrow::before {
    content: '';
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: rgb(var(--blackr));
    flex-shrink: 0;
  }

  .header {
    margin-bottom: 48px;
  }

  .header h2 {
    margin: 0;
    font-size: 32px;
    font-weight: 600;
    color: rgb(var(--blackr));
    line-height: 1.3;
  }

  .header p {
    margin: 0;
    font-size: 32px;
    font-weight: 600;
    color: rgba(var(--greyr), 0.6);
    line-height: 1.3;
  }

  .cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }

  .card {
    background: rgba(var(--greyr), 0.08);
    border-radius: 12px;
    padding: 28px;
    display: flex;
    flex-direction: column;
    min-height: 300px;
    .video-container{
      aspect-ratio: 1 / 1;
      border-radius: 16px;
      overflow:hidden;
      margin-bottom: 40px;
    }
    video{
      width: 100%;
      min-height: 100%;
      opacity: 0.1!important;
      height: auto;
      border-radius: 10px;
    }
  }

  .card-label {
    font-size: 13px;
    color: rgba(var(--greyr), 0.9);
    margin: 0 0 16px 0;
  }

  .card-stat {
    font-size: 20px;
    font-weight: 600;
    color: rgb(var(--blackr));
    margin: 0 0 12px 0;
  }

  .card-quote {
    font-size: 15px;
    line-height: 1.6;
    color: rgba(var(--greyr), 0.9);
    margin: 0;
    flex-grow: 1;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;

    .cards {
      grid-template-columns: 1fr;
    }
  }

}
`;

const highlightsTop= [
  {
    label: 'Data coverage',
    stat: '17 data domains',
    vid: '1.mp4',
    description:
      "From equities and crypto to SEC filings, insider activity, ESG scores, credit ratings, and economic indicators, it's all in one SDK and REST API instead of a dozen separate vendors.",
  },
  {
    label: 'Developer experience',
    vid: '2.mp4',
    stat: 'One SDK, one key',
    description:
      'Authenticate once and pull structured data across every domain, from historical prices to full filings, with built-in caching and pandas-ready output from the first request.',
  },
];

const highlightsBottom = [
  {
    label: 'Quant tooling',
    stat: '25+ indicators',
    vid: '3.mp4',
    description:
      'Built-in technical analysis, regression and beta models, and LSTM forecasting mean you can go from raw data to a working signal without leaving Python.',
  },
  {
    label: 'Visualization',
    stat: 'Plotly-native',
    vid: '5.mp4',
    description:
      'Interactive charts are built directly into the SDK, so you can inspect a dataset or share a finding without exporting to another tool first.',
  },
];

const Comp = () => {
  return (
    <StyledComp>
      <div className="grid">

        <div>
          <div className="header">
            <h2 className="serif">Built on proprietary financial data most platforms don&rsquo;t touch</h2>
            <p className="serif">A closer look at what&rsquo;s inside Axion</p>
          </div>

          <div className="cards">
            {highlightsTop.map((h) => (
              <div className="card" key={h.label}>
                <LazyVideo classNames={`vid`} src={ `https://cdn.studio14a.com/axion/about/${h.vid}` } />
                <p className="card-label">{h.label}</p>
                <p className="card-stat">{h.stat}</p>
                <p className="card-quote">{h.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Marquee/>

      <div className="grid">

        <div>
          <div className="header">
            <h2 className="serif">Tools built for research, not just retrieval</h2>
            <p className="serif">The quant layer underneath the data</p>
          </div>

          <div className="cards">
            {highlightsBottom.map((h) => (
              <div className="card" key={h.label}>
                <LazyVideo classNames={`vid`} src={ `https://cdn.studio14a.com/axion/about/${h.vid}` } />
                <p className="card-label">{h.label}</p>
                <p className="card-stat">{h.stat}</p>
                <p className="card-quote">{h.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

    </StyledComp>
  );
};

export default Comp;
